import { Link } from 'react-router-dom';
import React from 'react';

function Formen() {
    return (

        <div
            className="bg-formen-wrapper view"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-rosa.svg'})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom left',
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <main className="container" role="main">

                <Link to="/" className="back-btn">← Zurück</Link>
                <h1 className="section-title">Melodien</h1>
            


                    <div className="grid">


                        <Link to="/formenlernfeld1" className="maincard card1" aria-label="FormenLernfeld1">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-musikalische-formen.png'} alt="FormenLernfeld1" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">Tempo</h2>
                                <p className="card__desc">Tempo von Melodien unterscheiden</p>
                            </div>
                        </Link>

                        <Link to="/formenlernfeld2" className="maincard card2" aria-label="FormenLernfeld2">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-musikalische-formen.png'} alt="FormenLernfeld2" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">Wiederholung & Variation</h2>
                                <p className="card__desc">Wiederholung und Variation unterscheiden</p>
                            </div>
                        </Link>
                    </div>
                    </main>
                </div>
           

    );
}

export default Formen;